import React from 'react';
import {
  StoreExpiredCouponContainer,
  StoreExpiredCouponsList,
  StoreExpiredCouponSubTitle,
  StoreExpiredCouponTitle,
} from './style';
import StoreExpiredCouponCard from '../StoreExpiredCouponCard';
import useHashCouponModal from '../../hooks/useHashCouponModal';
import { StoreDeal } from '../../../domain/entities/Store';
import { useTranslation } from '../../hooks/useTranslation';

type StoreExpiredCouponsType = {
  expiredCoupons?: StoreDeal[];
  revealCoupons: boolean;
  currentUserId?: string;
};

const StoreExpiredCoupons = ({
  expiredCoupons,
  revealCoupons,
  currentUserId,
}: StoreExpiredCouponsType) => {
  useHashCouponModal({
    enabled: revealCoupons,
    coupons: expiredCoupons,
    isExpiredCoupon: true,
  });

  const { t } = useTranslation('coupons');
  const redirectToStore = (url: string) => {
    if (url) {
      window.open(url, '_blank');
    }
  };

  return (
    <StoreExpiredCouponContainer>
      <StoreExpiredCouponTitle>
        {t('store-expired-coupon-title')}
      </StoreExpiredCouponTitle>
      <StoreExpiredCouponSubTitle>
        {t('store-expired-coupon-subtitle')}
      </StoreExpiredCouponSubTitle>
      <StoreExpiredCouponsList>
        {expiredCoupons?.map((expiredCoupon) => (
          <StoreExpiredCouponCard
            key={expiredCoupon.id}
            expiredCoupon={expiredCoupon}
            redirectToStore={redirectToStore}
            currentUserId={currentUserId}
          />
        ))}
      </StoreExpiredCouponsList>
    </StoreExpiredCouponContainer>
  );
};

export default StoreExpiredCoupons;
